import { FaAngleDown } from "react-icons/fa";
import { BsTicketPerforated, BsThreeDotsVertical } from "react-icons/bs";
import { SlCalender } from "react-icons/sl";
import Menu from "@mui/material/Menu";
import { useState, useEffect, useMemo } from "react";
import getAssignedTasks from "../../controllers/Tasks/getTasks";
import getCreatedTasks from "../../controllers/Tasks/getCreatedTasks";
import { useSelector } from "react-redux";
import Pagination from "@mui/material/Pagination";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { CircularProgress } from "@mui/material";
import updateTaskStatus from "../../controllers/Tasks/updateStatus";
import { enqueueSnackbar } from "notistack";
import TaskCard from "../../components/tasks/TaskCard";
import ViewTaskModal from "../../components/modal/taskManagement/ViewTaskModal";
import approveChangeTicketRequest from "../../controllers/booking/postTicketing/change/approveChangeTicketRequest";
import DeclineTask from "../../components/tasks/DeclineTask";
import TaskRemarkModal from "../../components/modal/taskManagement/TaskRemarkModal";
import { openTaskRoute } from "../../utils/task/taskUtilFun";
import useAccount from "../../hooks/useAccount";

function Tasks() {
  const [anchorEl, setAnchorEl] = useState(null);
  const [loadings, setLoadings] = useState({ load: false });
  const { user } = useSelector((state) => state.user.userData);
  const { checkPermission } = useAccount();
  const [data, setData] = useState([]);
  const [selectedTask, setSelectedTask] = useState(null);
  const openAnchorEl = Boolean(anchorEl);
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const offset = page * limit;
  const [total, setTotal] = useState(0);
  const [statusFilter, setStatusFilter] = useState("ALL");
  const [loadingStatus, setLoadingStatus] = useState(false);
  const [affect, setAffect] = useState(0);
  const [open, setOpen] = useState(false);
  const [statusAnchorEl, setStatusAnchorEl] = useState(null);
  const openStatusMenu = Boolean(statusAnchorEl);
  const [openDenyChange, setOpenDenyChange] = useState(false);
  const [modalType, setModalType] = useState("ViewTask");
  const [openUpdateChangeRequest, setOpenUpdateChangeRequest] = useState(false);

  console.log(user);

  async function load() {
    setLoadings({ load: true });
    let res;
    if (user?.userType === "Admin") {
      res = await getCreatedTasks({ offset, limit });
    } else {
      res = await getAssignedTasks({ offset, limit });
    }
    setLoadings({ load: false });
    if (res?.return) {
      console.log("Fetched Tasks:", res?.data);
      setData(res.data.data);
      setTotal(res.data?.meta?.total);
    }
  }

  useEffect(() => {
    load();
  }, [page, limit, affect]);

  const handleOpenMenu = (event, task) => {
    setAnchorEl(event.currentTarget);
    setSelectedTask(task);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
    // setSelectedTask(null);
  };

  const statusList = useMemo(() => {
    const statuses = data.map((task) => task.taskStatus);
    return ["ALL", ...Array.from(new Set(statuses))];
  }, [data]);

  const filteredData = useMemo(() => {
    if (statusFilter === "ALL") return data;
    return data.filter((task) => task.taskStatus === statusFilter);
  }, [data, statusFilter]);

  async function handleAction(action) {
    if (!selectedTask) return;

    switch (action) {
      case "ViewTask":
        setModalType("ViewTask");
        setOpen(true);
        handleCloseMenu();
        break;

      case "AcceptTask":
        try {
          setLoadingStatus(true);

          const res = await approveChangeTicketRequest(
            selectedTask?.changeOrderManagement?._id
          );

          if (!res?.return) {
            enqueueSnackbar(res?.msg || "Failed to update task", {
              variant: "error",
            });
            return;
          }

          enqueueSnackbar("Task updated successfully", { variant: "success" });
          setAffect((p) => p + 1);
        } catch {
          enqueueSnackbar("Something went wrong", { variant: "error" });
        } finally {
          setLoadingStatus(false);
          setStatusAnchorEl(null);
          handleCloseMenu();
        }
        break;
      case "ReAssignTask":
        setOpen(true);
        setModalType("ReAssignTask");
        handleCloseMenu();
        break;

      case "RejectTask":
        setOpenDenyChange(true);
        handleCloseMenu();
        break;
      case "OfflineTicketIssue":
        console.log("offline ticket issue");
        break;

      case "ViewRequest":
      case "AddRemarks":
      case "CreateQuote":
      case "DeclineRequest":
        openTaskRoute(action, selectedTask);
        console.log(action, selectedTask);
        break;
      default:
        break;
    }

    handleCloseMenu();
  }

  async function handleStatus(status) {
    if (!selectedTask) return;

    try {
      setLoadingStatus(true);

      const res = await updateTaskStatus(selectedTask._id, { status });

      if (!res?.return) {
        enqueueSnackbar(res?.msg || "Failed to update task", {
          variant: "error",
        });
        return;
      }

      enqueueSnackbar("Task updated successfully", { variant: "success" });
      setAffect((p) => p + 1);
    } catch {
      enqueueSnackbar("Something went wrong", { variant: "error" });
    } finally {
      setLoadingStatus(false);
      setStatusAnchorEl(null);
      handleCloseMenu();
    }
  }

  const STATUS_CONFIG = {
    ToDo: "To Do",
    InProgress: "In Progress",
    OnHold: "On Hold",
    Done: "Completed",
  };

  const TASK_TYPE_MENU = {
    Ticketing: {
      afterDivider: [
        "ViewRequest",
        "OfflineTicketIssue",
        "AddRemarks",
        "DeclineRequest",
      ],
    },
    Void: {
      afterDivider: ["ViewRequest", "AddRemarks", "DeclineRequest"],
    },
    Refund: {
      afterDivider: [
        "ViewRequest",
        "AddRemarks",
        "CreateQuote",
        "DeclineRequest",
      ],
    },
    Support: {
      afterDivider: [
        "ViewRequest",
        "AddRemarks",
        "CreateQuote",
        "DeclineRequest",
      ],
    },
    ChangeOrder: {
      afterDivider: [
        "ViewRequest",
        "AddRemarks",
        "CreateQuote",
        "DeclineRequest",
      ],
    },
  };

  const ACTION_LABELS = {
    ViewTask: "View task",
    AcceptTask: "Accept task",
    ReAssignTask: "Re assign task",
    RejectTask: "Reject task",
    UpdateStatus: "Update task status",

    ViewRequest: "View request",
    OfflineTicketIssue: "Offline ticket issue",
    AddRemarks: "Add remarks",
    CreateQuote: "Create quote",
    DeclineRequest: "Decline request",
  };

  const canReAssign = checkPermission("update:assign-agent");

  return (
    <>
      <div className="bg-[#F3F5F9] px-20 py-10 min-h-screen flex flex-col space-y-12">
        <TasksHeader
          statuses={statusList}
          statusFilter={statusFilter}
          setStatusFilter={setStatusFilter}
        />
        <hr className="border-b border-gray-300" />
        {loadings.load ? (
          <div className="flex items-center justify-center">
            <CircularProgress />
          </div>
        ) : (
          <div className="flex flex-col space-y-3">
            {filteredData.length === 0 ? (
              <div className="text-center text-gray-500 mt-10 text-2xl">
                No tasks available.
              </div>
            ) : (
              <div className="w-full bg-white rounded-md border border-gray-200">
                {filteredData?.map((task, index) => (
                  <TaskCard
                    key={index}
                    task={task}
                    handleOpenMenu={handleOpenMenu}
                  />
                ))}
                <Menu
                  anchorEl={anchorEl}
                  open={openAnchorEl}
                  onClose={handleCloseMenu}
                  anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                  transformOrigin={{ vertical: "top", horizontal: "right" }}
                  PaperProps={{ sx: { mt: 1, minWidth: 200, borderRadius: 1 } }}
                >
                  <MenuItem onClick={() => handleAction("ViewTask")}>
                    {ACTION_LABELS.ViewTask}
                  </MenuItem>

                  {canReAssign && (
                    <MenuItem onClick={() => handleAction("ReAssignTask")}>
                      {ACTION_LABELS.ReAssignTask}
                    </MenuItem>
                  )}

                  <MenuItem onClick={(e) => setStatusAnchorEl(e.currentTarget)}>
                    {ACTION_LABELS.UpdateStatus}
                  </MenuItem>

                  <hr className="border border-b border-gray-300" />

                  {TASK_TYPE_MENU[selectedTask?.taskType]?.afterDivider.map(
                    (action) => (
                      <MenuItem
                        key={action}
                        onClick={() => handleAction(action)}
                      >
                        {ACTION_LABELS[action]}
                      </MenuItem>
                    )
                  )}
                </Menu>

                <Menu
                  anchorEl={statusAnchorEl}
                  open={openStatusMenu}
                  onClose={() => setStatusAnchorEl(null)}
                  anchorOrigin={{ vertical: "center", horizontal: "right" }}
                  transformOrigin={{ vertical: "top", horizontal: "left" }}
                >
                  {Object.entries(STATUS_CONFIG).map(([status, label]) => (
                    <MenuItem key={status} onClick={() => handleStatus(status)}>
                      {label}
                    </MenuItem>
                  ))}
                </Menu>
              </div>
            )}
            <div className="flex items-center justify-between px-6 py-4 border-t">
              {/* Rows per page */}
              <div className="flex items-center gap-2">
                <span className="text-sm text-gray-600">Rows per page:</span>
                <Select
                  size="small"
                  value={limit}
                  onChange={(e) => {
                    setPage(0);
                    setLimit(Number(e.target.value));
                  }}
                >
                  {[5, 10, 20, 50].map((size) => (
                    <MenuItem key={size} value={size}>
                      {size}
                    </MenuItem>
                  ))}
                </Select>
              </div>

              {/* Pagination */}
              <Pagination
                color="primary"
                page={page + 1}
                count={Math.ceil(total / limit)}
                onChange={(_, value) => setPage(value - 1)}
              />
            </div>
          </div>
        )}
      </div>
      {open && (
        <ViewTaskModal
          data={selectedTask}
          open={open}
          onClose={() => setOpen(false)}
          setAffect={setAffect}
          type={modalType}
        />
      )}
      <DeclineTask
        data={selectedTask}
        openDenyChange={openDenyChange}
        setOpenDenyChange={setOpenDenyChange}
        setAffect={setAffect}
      />
      <TaskRemarkModal
        data={selectedTask}
        openUpdateChangeRequest={openUpdateChangeRequest}
        setOpenUpdateChangeRequest={setOpenUpdateChangeRequest}
        setAffect={setAffect}
      />
    </>
  );
}

export default Tasks;

function TasksHeader({ statuses, statusFilter, setStatusFilter }) {
  return (
    <div className="flex flex-col space-y-5">
      <h4>Tasks</h4>
      <div className="flex justify-between items-end">
        <div className="flex space-x-3">
          {statuses.map((status) => (
            <button
              key={status}
              onClick={() => setStatusFilter(status)}
              className={`px-5 py-3 rounded-md shadow-md capitalize ${
                statusFilter === status ? "bg-[#4E5662] text-white" : "bg-white"
              }`}
            >
              {status === "ALL" ? "All Tasks" : status}
            </button>
          ))}
        </div>

        <div className="flex space-x-3 items-end">
          <div>
            <button className="text-primary1 px-5 py-2 rounded-md text-xl font-medium">
              Export
            </button>
          </div>
          <div className="bg-[#DBDBDB] px-5 py-2 text-white rounded-md shadow-md flex space-x-2  items-center">
            <button className="text-primaryText px-5 py-2 rounded-md  bg-white">
              Weekly
              <FaAngleDown className="inline ml-2" />
            </button>
            <p className="font-medium">1st Jul - 31st Jul</p>
            <SlCalender className="text-blue-800" />
          </div>
        </div>
      </div>
    </div>
  );
}
